import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Dashboard from "./pages/Dashboard";
import Membership from "./pages/Membership";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Pledge from "./pages/Pledge";
import PledgeConfirmation from "./pages/PledgeConfirmation";
import Checkout from "./pages/Checkout";
import ShipNow from "./pages/ShipNow";
import PaymentSuccess from "./pages/PaymentSuccess";
import MyOrders from "./pages/MyOrders";
import ResetPassword from "./pages/ResetPassword";
import Admin from "./pages/Admin";
import AITakeoff from "./pages/AITakeoff";
import Terms from "./pages/Terms";
import PaymentPolicy from "./pages/PaymentPolicy";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

function AppRouter() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:productId" element={<ProductDetail />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/pledge" element={<Pledge />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/ship-now" element={<ShipNow />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/my-orders" element={<MyOrders />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/pledge/confirmation" element={<PledgeConfirmation />} />
        <Route path="/ai-takeoff" element={<AITakeoff />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/payment-policy" element={<PaymentPolicy />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
